module.exports = __webpack_public_path__ + "img/bd_rowa_rgb.db48d6c5.png";